<div class="modal fade" id="kt_modal_country_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-750px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Country' : 'Add Country' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="countryForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Country Name -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Country Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter country name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Country name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Country name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Region -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Region</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="region"
                placeholder="Enter region"
              />

            </div>

            <!-- Parent Country -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Parent Country</label>
              <select
                class="form-select form-select-solid"
                formControlName="parent"
              >
                <option value="">Select parent country</option>
                <option *ngFor="let country of parentCountries" [value]="country._id">{{ country.name }}</option>
              </select>
            </div>

            <!-- Port -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Port</label>
              <select
                class="form-select form-select-solid"
                formControlName="port"
              >
                <option value="">Select port</option>
                <option *ngFor="let port of portList" [value]="port._id">{{ port.name }}</option>
              </select>
            </div>

            <!-- Inspection Multi-select -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Inspection</label>
              <div class="dropdown">
                <button
                  class="btn btn-outline-secondary dropdown-toggle w-100 text-start"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <span *ngIf="inspection?.value?.length === 0">Select inspection types</span>
                  <span *ngIf="inspection?.value?.length > 0">{{ inspection?.value?.length }} selected</span>
                </button>
                <ul class="dropdown-menu w-100" style="max-height: 200px; overflow-y: auto;">
                  <li *ngFor="let option of inspectionOptions" class="dropdown-item-text px-3 py-2" (click)="$event.stopPropagation()">
                    <div class="form-check mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="'inspection_' + option.value"
                        [checked]="isInspectionSelected(option.value)"
                        (change)="toggleInspection(option.value)"
                        (click)="$event.stopPropagation()">
                      <label class="form-check-label" [for]="'inspection_' + option.value">
                        {{ option.label }}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Ship Method Checkboxes -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Ship Method</label>
              <div class="row">
                <div class="col-md-6" *ngFor="let method of shipMethodOptions">
                  <div class="form-check mb-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'ship_method_' + method.value"
                      [checked]="isShipMethodSelected(method.value)"
                      (change)="toggleShipMethod(method.value)">
                    <label class="form-check-label" [for]="'ship_method_' + method.value">
                      {{ method.label }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
